import { mapServerSideClient } from '@/utils/api.mapper'
import { getInstanceWithToken } from '@/utils/axios'
import { Client, ServerSideClient } from './types'

export const fetchClients = async (): Promise<Client[]> => {
  const { data } = await getInstanceWithToken().get<ServerSideClient[]>('api/clients')

  return data.map(mapServerSideClient)
}

export const fetchClient = async (clientId: number): Promise<Client> => {
  const { data } = await getInstanceWithToken().get<ServerSideClient>(`api/clients/${clientId}`)

  return mapServerSideClient(data)
}

export default fetchClients
